<template>
  <v-container>
    <h2>Create customer</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.firstname"
              label="Firstname"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.lastname"
              label="Lastname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.display_name"
              label="Display name/nickname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.email"
              label="Email"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.phone_number"
              label="Phone number"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.line_id"
              label="Line ID"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.facebook_name"
              label="Facebook name"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-switch
              v-model="customer.active"
              label="Active"
              inset
              color="orange"
            ></v-switch>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="createCustomer"
          >
            Create
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'customer-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CustomerCreate",
  components: {

  },
  data: () => ({
    customer: {
      firstname: null,
      lastname: null,
      display_name: null,
      email: null,
      phone_number: null,
      line_id: null,
      facebook_name: null
    },
    rules: {
      profile_image: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      require: value => !!value || 'Please fill in information',
      personal_id: value => !value || value.length < 14 || 'Personal ID must have 13 digits',
    },
  }),
  methods: {
    async createCustomer () {
      try {
        if (this.requireField()) {
          await this.$http.post('/back-office/customers', this.customer, authHeader())
          this.$router.push({ name: 'customer-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.customer.firstname) {
        alert('Please fill in firstname')
        return false;
      }
      return true
    }
  },
};
</script>
